export default {
	methods: {
		resetFormMethods() {
			if (this.elFormItem) {
				const { resetField: formItemResetField, clearValidate: formItemClearValidate } = this.elFormItem;

				this.elFormItem.validate = (trigger, callback) => {
					this.validate(callback);
				};

				this.elFormItem.resetField = () => {
					this.resetField();
					formItemResetField();
				};

				this.elFormItem.clearValidate = () => {
					this.clearValidate();
					formItemClearValidate();
				};
			}
		}
	}
};
